export const getYearFormat = (year) => {
  if (year) {
    const yearString = year.toString();
    return `${yearString.slice(4, 6)}.${yearString.slice(0, 4)}`;
  } else {
    return '';
  }
};

export const getMotorCodes = (codesArray) => {
  let codes = [];

  if (codesArray) {
    codesArray.forEach((element) => {
      codes.push(element.motorCode);
    });
  }

  return codes.join(' ');
};



// WEBPACK FOOTER //
// ./src/utils/formatDataHelper/formatDataHelper.js